import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Tilitystiedot',
    payouts: 'Tilitykset',
  },
  form: {
    invoicing_emails: {
      label: 'Lähetä laskut osoitteeseen',
      placeholder: 'Anna sähköpostiosoitteesi',
    },
    payout_schedule: {
      label: 'Tilitysaikataulu',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Tilitykset keskeytetty',
        [PAYOUT_INTERVAL.DAILY]: 'Päivittäiset tilitykset',
        [PAYOUT_INTERVAL.WEEKLY]: 'Viikoittaiset tilitykset',
        [PAYOUT_INTERVAL.MONTHLY]: 'Kuukausittaiset tilitykset',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Ravintola',
    amount: 'Summa',
    cash_amount: 'Käteissumma',
    paypal_standalone_amount: 'PayPal-summa',
    period: 'Jakso',
    paid_at: 'Maksettu',
    provider: 'Palveluntarjoaja',
    status: 'Tila',
    actions: 'Toiminnot',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Käteinen',
    system: 'Järjestelmä',
  },
  buttons: {
    save: 'Tallenna',
    actions: 'Toiminnot',
    open_report: 'Avaa raportti',
    open_tracking_url: 'Seuraa tilitystä',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Odottaa',
    [PAYOUT_STATUSES.processing]: 'Käsitellään',
    [PAYOUT_STATUSES.paid]: 'Maksettu',
    [PAYOUT_STATUSES.failed]: 'Epäonnistui',
    undefined: 'Tuntematon',
    null: 'Tuntematon',
  },
  toasts: {
    failed_to_load_data: 'Tietojen haku epäonnistui',
    successfully_updated: 'Päivitetty onnistuneesti',
  },
};
